import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { Cliente } from 'src/app/model/cliente.model';
import { Permissoes } from 'src/app/model/permissao.model';
import { AlertService } from 'src/app/service/alert.service';
import { ClientesService } from 'src/app/service/clientes.service';
import { ContratosService } from 'src/app/service/contratos.service';
import { PermissoesService } from 'src/app/service/permissoes.service';
import { ProdutosService } from 'src/app/service/produtos.service';

@Component({
  selector: 'app-criar-contrato',
  templateUrl: './criar-contrato.component.html',
  styleUrls: ['./criar-contrato.component.css']
})
export class CriarContratoComponent implements OnInit {

  constructor(
    private serviceClientes: ClientesService, 
    private router: Router, 
    private produtoService: ProdutosService,
    private formBuilder: FormBuilder,
    private service: ContratosService,
    private alertService: AlertService,) {
      this.form = this.formBuilder.group({
        ts_data_vencimento: new FormControl('', [Validators.required]),
        fk_produto: new FormControl('', [Validators.required]),
        fk_cliente:new FormControl('', [Validators.required]),
      })
     }

  clientes!: Cliente[];
  load = false;
  value = 50;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  form!: FormGroup;
  produtos = [] as any

  ngOnInit(): void {
    this.listarClientes();
    this.listarProdutos();
  }

  listarClientes(){
    this.serviceClientes.listarServiceClientes().subscribe(resp => {
      this.clientes = resp;
    })
  }

  listarProdutos(){
    this.produtoService.listarService().subscribe((resp:any) => {
      this.produtos = resp.filter(function(elem:any) {
        return elem.sr_id != 1
      })
    },error => {

    })
  }

  cancel(){
    this.router.navigate(['configuracao/contratos']);
  }
 
  cadastrar(): void {
    this.form.value.ts_data_vencimento = this.form.value.ts_data_vencimento.toISOString().replace(/T/, " ").replace(/\..+/, "")
    this.service.cadastrarService(this.form.value).subscribe((resp) => {
      this.alertService.success();
      this.router.navigate(['configuracao/contratos']);
    }, error => {
      this.alertService.error(error);
    }
    )
  }
}
